import {
	commonSelectPropsToSelectProps,
	FormRadio,
	FormSelect,
	FormSideOffsetLayout,
	LightbulbMessage,
} from '@gov-nx/ui/web';
import type { FormDefinition2 } from '@gov-nx/core/service';
import type { RezaChangeData, RezaChangeFields } from '@gov-nx/core/hooks';
import type { Optional } from '@gov-nx/core/types';
import { RezaEligibleListSkeleton } from './RezaEligibleListSkeleton';

interface RezaChangeFormViewProps {
	form: FormDefinition2<RezaChangeData, RezaChangeFields>;
	isEligibleListLoading: boolean;
	isRepresentationAllowed: boolean;
	hasRepresentationOptions: boolean;
	singleOptionAsText?: {
		singleOptionLabel: Optional<string>;
		hasSingleOption: boolean;
	};
	role?: RezaChangeData['role'];
	strings: {
		representationNotAllowed: string;
		representationListNotFound: string;
	};
}

export const RezaChangeFormView = ({
	form,
	isEligibleListLoading,
	isRepresentationAllowed,
	hasRepresentationOptions,
	singleOptionAsText,
	role,
	strings,
}: RezaChangeFormViewProps) => {
	const { singleOptionLabel, hasSingleOption } = singleOptionAsText || {};

	return (
		<>
			<FormRadio {...form.fields.role} />

			{!isRepresentationAllowed ? (
				<LightbulbMessage message={strings.representationNotAllowed} />
			) : null}

			{role === 'v_zastoupeni' ? (
				isEligibleListLoading ? (
					<RezaEligibleListSkeleton />
				) : hasRepresentationOptions ? (
					hasSingleOption && singleOptionLabel ? (
						<FormSideOffsetLayout>
							<strong>{singleOptionLabel}</strong>
						</FormSideOffsetLayout>
					) : (
						<FormSelect
							{...commonSelectPropsToSelectProps(form.fields.rezaCode)}
						/>
					)
				) : (
					<LightbulbMessage message={strings.representationListNotFound} />
				)
			) : null}
		</>
	);
};
